import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useSpacesContext } from "@circle-react/contexts/spacesContext";

export const useCanCreatePost = () => {
  const { helpers: spaceHelpers } = useSpacesContext();
  const { currentCommunityMember } = usePunditUserContext();

  const spacesAllowedLength =
    spaceHelpers.basicSpacesWithPostCreationAllowed().length;

  const canCreatePost = Boolean(currentCommunityMember && spacesAllowedLength);

  return {
    canCreatePost,
  };
};
